const ENV = window.location.href.indexOf('deploy-preview') > -1 ? 'staging' : process.env.NODE_ENV;

export default {
  API: {
    tc: {
      development: 'https://frasier.staging.de-2.nsoft.cloud',
      staging: 'https://frasier.staging.de-2.nsoft.cloud',
      production: 'https://frasier.de-2.nsoft.cloud'
    },
    socket: {
      development: 'wss://sports-mts-api.staging.gb.nsoftcdn.com',
      staging: 'wss://sports-mts-api.staging.gb.nsoftcdn.com',
      production: 'wss://sports-mts-api.gb.nsoftcdn.com',
    },
    offer: {
      development: 'https://sports-mts-services-api.staging.gb.nsoftcdn.com/prematchOffer',
      staging: 'https://sports-mts-services-api.staging.gb.nsoftcdn.com/prematchOffer',
      production: 'https://sports-mts-services-api.gb.nsoftcdn.com/prematchOffer',
    },
    configuration: {
      development: 'https://sports-mts-api.staging.gb.nsoftcdn.com/clientConfiguration.php',
      staging: 'https://sports-mts-api.staging.gb.nsoftcdn.com/clientConfiguration.php',
      production: 'https://sports-mts-api.gb.nsoftcdn.com/clientConfiguration.php',
    },
    sevenApi: {
      development: 'https://services-staging.7platform.com/app.php',
      staging: 'https://services-staging.7platform.com/app.php',
      production: 'https://menhir.{dcUrlCloudflareFragment}.nsoftcdn.com',
    },
  },
  appSettings: {
    maxSports: 8,
    tournamentFilter: {
      rows: 2,
    },
    categoriesFilter: {
      rows: 3,
    },
    statistics: {
      enabled: false,
      link: 'https://s5.sir.sportradar.com/',
      clientId: 'betradar',
    },
    ticket: {
      tabs: [
        {
          id: '3',
          name: 'single',
          position: 1,
          disabled: false,
        }, {
          id: '1',
          name: 'combo',
          position: 2,
          disabled: false,
        }, {
          id: '2',
          name: 'system',
          position: 3,
          disabled: false,
        },
      ],
      activeType: '1',
    },
    socket: {
      enabled: true,
      contentEncoding: 'deflate',
    },
  },
  standaloneAppData: {
    device: {
      uuid: 'f0bd1bf3-be54-471e-b3d1-0f96779b9f6b',
      deviceUuid: 'f0bd1bf3-be54-471e-b3d1-0f96779b9f6b',
      name: 'Dummy device',
      moneyDenominations: [3, 10, 50, 100],
      balance: 3055,
    },
    terminal: {
      name: 'Dummy terminal',
      uuid: 'af837fb6-0ffb-4f9a-9329-407edc542b98',
    },
    company: {
      currency: 'BAM',
      locale: 'en',
      name: 'Prva firma',
      uuid: 'b99752b3-443c-4c80-b559-945a95c4b805',
    },
    product: {
      cpvUuid: '1072b9b0-d247-41a2-b64d-967ce5697e54',
    },
    env: 'staging',
  },
  companies: {
    'b99752b3-443c-4c80-b559-945a95c4b805': {
      comment: 'Prva Firma :: STAGING',
      appSettings: {
        maxSports: 5,
        statistics: {
          enabled: true,
        },
        ticket: {
          tabs: [
            {
              id: '3',
              name: 'single',
              position: 3,
              disabled: false,
            }, {
              id: '1',
              name: 'combo',
              position: 1,
              disabled: false,
            }, {
              id: '2',
              name: 'system',
              position: 2,
              disabled: false,
            },
          ],
          activeType: '3',
        },
        socket: {
          enabled: true,
          contentEncoding: 'cleartext',
        },
      },
    },
    '347d05a9-aec0-408c-a437-d7043f317051': {
      comment: 'Magic Club :: PRODUCTION',
      appSettings: {
        statistics: {
          enabled: false,
        },
      },
    },
    '87ec8189-2a01-4e69-b814-c918ebaf7e72': {
      comment: 'Minja Company :: STAGING',
      appSettings: {
        tournamentFilter: {
          rows: 1,
        },
      },
    },
    '6c78d15c-4421-40e7-92f0-4def495b1a18': {
      comment: 'Bingo Bet :: PRODUCTION',
      dcUrl: '-ro',
      dcUrlCloudflare: 'ro',
    },
    '86afd4cc-c0ab-4745-bf04-e8e7f10839f6': {
      comment: 'Livebet 1x2 :: PRODUCTION',
      dcUrl: '-ro',
      dcUrlCloudflare: 'ro',
    },
    '4b737004-ec63-4e05-8bdc-3e09c1b31e29': {
      comment: 'Total Bet :: PRODUCTION',
      dcUrl: '-ro',
      dcUrlCloudflare: 'ro',
    },
    'b16d902f-c071-4cee-b648-a173def0e641': {
      comment: 'Expo US LAS VEGAS :: STAGING',
      appSettings: {
        ticket: {
          tabs: [
            {
              id: '3',
              name: 'single',
              position: 1,
              disabled: false,
            }, {
              id: '1',
              name: 'combo',
              position: 2,
              disabled: false,
            }, {
              id: '2',
              name: 'system',
              position: 2,
              disabled: true,
            },
          ],
          activeType: '1',
        }
      },
    }
  },
  env: ENV,
};
